import React from "react";
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap";

interface StatusCardProps {
  status: string;
  statusInfo: {
    color: string;
    icon: React.ReactNode;
    label: string;
  };
  moveType: string;
  moveTypeInfo: {
    color: string;
    icon: React.ReactNode;
    label: string;
  };
  stockType?: string;
}

const StatusCard: React.FC<StatusCardProps> = ({
  statusInfo,
  moveTypeInfo,
  stockType,
}) => {
  const { t } = useTranslation();
  const renderItem = (title: string, value: string, icon: React.ReactNode, color: string) => (
    <div className="d-flex align-items-center gap-3">
      <div
        style={{
          width: 50,
          height: 50,
          borderRadius: 12,
          backgroundColor: `rgba(var(--bs-${color}-rgb), 0.15)`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(var(--bs-${color}-rgb), 0.2)",
          transition: "transform 0.2s",
        }}
        className="hover-elevate"
      >
        <span className={`text-${color}`} style={{ fontSize: 22 }}>{icon}</span>
      </div>
      <div className="d-flex flex-column">
        <small className="text-body-secondary text-uppercase fw-light" style={{ fontSize: 12, letterSpacing: "0.5px" }}>
          {title}
        </small>
        <span className={`fw-semibold text-${color}`} style={{ fontSize: 16 }}>{value}</span>
      </div>
    </div>
  );

  return (
    <Card
      className="mb-4 status-card"
      style={{
        borderRadius: "18px",
        background: "var(--bs-card-bg)",
        padding: "1.5rem",
        boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        transition: "all 0.3s ease",
        border: "1px solid var(--bs-border-color)"
      }}
    >
      <style>
        {`
          .status-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(0,0,0,0.12);
          }
          .hover-elevate:hover {
            transform: scale(1.05);
          }
        `}
      </style>
      <Row className="gy-4 gx-5 justify-content-between">
        <Col md={4}>
          {renderItem(t("inventoryDetails.status"), statusInfo.label, statusInfo.icon, statusInfo.color)}
        </Col>
        <Col md={4}>
          {renderItem(t("inventoryDetails.moveType"), moveTypeInfo.label, moveTypeInfo.icon, moveTypeInfo.color)}
        </Col>
        <Col md={4}>
          {renderItem(
            t("inventoryDetails.stockType"),
            stockType === "drop" ? t("inventoryHistory.stockType.easyShipping") : t("inventoryHistory.stockType.fbw"),
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round"
              className={`text-${stockType === "drop" ? "secondary" : "primary"}`}>
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
            </svg>,
            stockType === "drop" ? "secondary" : "primary"
          )}
        </Col>
      </Row>
    </Card>
  );
};

export default StatusCard;
